import React from "react";
import { ActivityFeedBlock } from "./CoachingAthletesPage";

export default function CoachActivityPage() {
  return (
    <div className="min-h-screen bg-[var(--tir-ivory)]" data-testid="coach-activity-page">
      <div className="max-w-5xl mx-auto px-5 lg:px-8 py-8">
        <ActivityFeedBlock />
      </div>
    </div>
  );
}
